import { Currency } from "@/components/Currency";
import { Text } from "@repo/skapa";
import { Input } from "@repo/skapa";
import { useState } from "react";

interface CurrencyFieldProps {
  id: string;
  label: string;
  value?: number;
  editable?: boolean;
  onChange?: (newValue?: number) => void;
  currency?: string;
}
export const CurrencyField = ({
  id,
  label,
  value,
  currency,
  editable,
  onChange,
}: CurrencyFieldProps) => {
  const [textValue, setTextValue] = useState(value);

  return (
    <div>
      <Text textStyle="Heading.XS">{label}</Text>
      {editable ? (
        <Input
          id={id}
          type="text"
          value={textValue ?? ""}
          onChange={(e) => setTextValue(Number(e.target.value))}
          onBlur={() => {
            if (value !== textValue) {
              onChange?.(textValue);
            }
          }}
          prefixLabel={currency}
        />
      ) : (
        <Text>
          <Currency value={value} currency={currency} />
        </Text>
      )}
    </div>
  );
};
